<template>
  <div class="switch-tab">
    <el-row>
      <el-tooltip class="item" effect="dark" content="显示表格" placement="top" v-show="tableIcon">
        <svg-icon icon-class="table-out" style="width: 20px; height: 20px;" @click="showTable()" />
      </el-tooltip>
      <el-tooltip class="item" effect="dark" content="显示可视化" placement="top" v-show="echartsIcon">
        <svg-icon icon-class="statistics" style="width: 20px; height: 20px;" @click="showEcharts()" />
      </el-tooltip>
    </el-row>
  </div>
</template>

<script>
export default {
  data() {
    return {

    }
  },
  props: {
    tableIcon: {
      type: Boolean,
      default: true
    },
    echartsIcon: {
      type: Boolean,
      default: true
    }
  },
  components: {

  },
  mounted() {

  },
  methods: {
    showTable() {
      this.$emit("switchTab", "table");
    },
    showEcharts() {
      this.$emit("switchTab", "echarts");
    },
  },
}
</script>

<style lang="less" scoped>
.switch-tab {
  position: relative;
  // float: right;
  padding: 4px 0;
  .svg-icon {
    display: inline-block;
    color: #606266;
    vertical-align: middle;
    cursor: pointer;
    &:hover {
      color: @themeColor;
    }
  }
  .svg-icon + .svg-icon {
    margin-left: 10px;
  }
}
</style>